import React, { useContext, useEffect, useState } from 'react';

import { FEATURE_FLAG } from '@qality/common-config';
import { ProjectService } from '@qality/common-service';

import { DashboardView } from './Dashboard.view';
import { DashboardContext } from './DashboardProvider';

const Dashboard: React.FC = () => {
  const { projectKey, projectId, isQAlityConfigured } =
    useContext(DashboardContext);
  const [project, setProject] = useState(null);

  const nameSuffix = FEATURE_FLAG.isPremium ? 'Plus' : '';

  useEffect(() => {
    const init = async () => {
      if (projectKey) {
        setProject(await ProjectService.getProject(projectKey));
      }
    };
    init();
  }, []);

  return (
    <DashboardView
      project={project}
      projectKey={projectKey}
      projectId={projectId}
      projectName={project?.name}
      isQAlityConfigured={isQAlityConfigured}
      nameSuffix={nameSuffix}
    />
  );
};

export default Dashboard;
